import { monitorService } from "./service";

export const downloadInsuranceCoverageFile = async (
  insuranceCoverageMonitorId: string
): Promise<Blob> => {
  const { data } = await monitorService.get(
    `/${insuranceCoverageMonitorId}/download`,
    {
      responseType: "blob"
    }
  );

  return data;
};
